module.exports = __webpack_public_path__ + "img/12.956f2e13.jpg";